import { CoderuleClients } from '@coderule/clients';
import type { Logger } from 'pino';

import type { ResolvedConfig } from '../types';

function serviceConfig(
  baseUrl: string | undefined,
  timeout: number | undefined,
): { baseUrl?: string; timeout?: number } | undefined {
  if (baseUrl === undefined && timeout === undefined) {
    return undefined;
  }
  const config: { baseUrl?: string; timeout?: number } = {};
  if (baseUrl !== undefined) {
    config.baseUrl = baseUrl;
  }
  if (timeout !== undefined) {
    config.timeout = timeout;
  }
  return config;
}

export function createClients(
  config: ResolvedConfig,
  logger: Logger,
): CoderuleClients {
  const clientLogger = logger.child({ scope: 'clients' });
  const httpTimeout = config.httpTimeout;

  const clients = new CoderuleClients({
    token: config.token,
    auth: serviceConfig(config.authBaseUrl, httpTimeout),
    ast: serviceConfig(config.astBaseUrl, httpTimeout),
    sync: serviceConfig(config.syncBaseUrl, httpTimeout),
    retrieval: serviceConfig(config.retrievalBaseUrl, httpTimeout),
    jwtFactory: {
      onTokenRefreshed: (info) => {
        clientLogger.debug(
          {
            expiresAt: new Date(info.expiresAt).toISOString(),
            serverUrl: info.serverUrl,
          },
          'JWT refreshed',
        );
      },
    },
  });

  return clients;
}
